import { navLinks, noticeHighlights } from "@/mocks/gua";

export default function Footer() {
  return (
    <footer className="bg-background-900 text-background-200">
      <div className="mx-auto max-w-6xl px-4 py-14 md:px-6">
        {/* 品牌与统计 */}
        <div className="grid grid-cols-1 gap-8 md:grid-cols-12">
          <div className="md:col-span-5">
            <div className="flex items-center gap-3">
              <span className="flex h-9 w-9 items-center justify-center rounded-md bg-primary-500 text-background-50">
                <i className="ri-eye-off-fill text-lg" />
              </span>
              <span className="font-display text-2xl font-black tracking-tight text-background-50">吃瓜黑网</span>
            </div>
            <p className="mt-4 max-w-md text-sm leading-relaxed text-background-300">
              聚焦负面新闻与争议事件的独立观察栏目。塌房现场、翻车实录逐一还原，避雷名单持续收录，帮助你在消费与关注前先看清风险。
            </p>
            <div className="mt-6 grid grid-cols-3 gap-3">
              {noticeHighlights.map((n) => (
                <div key={n.label} className="rounded-md border border-background-800 bg-background-800/40 px-3 py-3 text-center">
                  <p className="font-display text-xl font-bold text-accent-400">{n.value}</p>
                  <p className="mt-1 text-[11px] text-background-300">{n.label}</p>
                </div>
              ))}
            </div>
          </div>

          <div className="md:col-span-3">
            <p className="text-xs font-semibold uppercase tracking-[0.25em] text-background-500">栏目导航</p>
            <ul className="mt-4 flex flex-col gap-2.5 text-sm">
              {navLinks.map((l) => (
                <li key={l.id}>
                  <a href={`#${l.id}`} className="text-background-200 transition-colors hover:text-accent-400">
                    {l.label}
                  </a>
                </li>
              ))}
            </ul>
          </div>

          <div className="md:col-span-4">
            <p className="text-xs font-semibold uppercase tracking-[0.25em] text-background-500">栏目准则</p>
            <ul className="mt-4 flex flex-col gap-3 text-sm leading-relaxed text-background-300">
              <li className="flex gap-2">
                <i className="ri-checkbox-circle-line mt-0.5 shrink-0 text-accent-400" />
                多源交叉核实后再上版，标注信息来源与核查时间。
              </li>
              <li className="flex gap-2">
                <i className="ri-shield-check-line mt-0.5 shrink-0 text-accent-400" />
                争议双方均保留回应与补充材料的通道，随时修订。
              </li>
              <li className="flex gap-2">
                <i className="ri-file-shield-2-line mt-0.5 shrink-0 text-accent-400" />
                本栏目内容仅为信息整理，不构成法律与投资判断依据。
              </li>
            </ul>
          </div>
        </div>
      </div>

      <div className="border-t border-background-800">
        <div className="mx-auto flex max-w-6xl flex-col gap-2 px-4 py-5 text-xs text-background-400 sm:flex-row sm:items-center sm:justify-between md:px-6">
          <p>© 2026 吃瓜黑网 · 内容主体均为虚构展示，仅供站内演示</p>
          <p className="flex items-center gap-2">
            <i className="ri-verified-badge-line text-accent-400" />
            理性吃瓜，不踩雷也不造谣
          </p>
        </div>
      </div>
    </footer>
  );
}